import React, { useEffect } from "react";

export default function AdsSquare() {
  useEffect(() => {
    try {
      if (!window.adsbygoogleLoaded) {
        const script = document.createElement("script");
        script.src =
          "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5162535306990850";
        script.async = true;
        script.crossOrigin = "anonymous";
        document.head.appendChild(script);

        window.adsbygoogleLoaded = true;
      }
      setTimeout(() => {
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {}
      }, 500);
    } catch (err) {
      console.log(err);
    }
  }, []);

  return (
    <div
      style={{
        width: "100%",
        textAlign: "center",
        margin: "15px 0",
      }}
    >
      {/* Sponsored Label */}
      <div
        style={{
          fontSize: "12px",
          color: "#666",
          fontWeight: "600",
          marginBottom: "8px",
          textTransform: "uppercase",
          letterSpacing: "1px",
        }}
      >
        Sponsored
      </div>

      <ins
        className="adsbygoogle"
        style={{
          display: "block",
          minHeight: "250px",
        }}
        data-ad-client="ca-pub-5162535306990850"
        data-ad-slot="2355314522"
      />
    </div>
  );
}
